import React from "react";
import { ArrowUpRight, ExternalLink, Clock } from "lucide-react";
import { loadTxs } from "@/lib/txstore";
import { CHAINS, fmtNum } from "@/lib/chains";

const explorer = {
  btc: (h) => `https://mempool.space/tx/${h}`,
  eth: (h) => `https://etherscan.io/tx/${h}`,
  bsc: (h) => `https://bscscan.com/tx/${h}`,
  polygon: (h) => `https://polygonscan.com/tx/${h}`,
  sol: (h) => `https://solscan.io/tx/${h}`,
  tron: (h) => `https://tronscan.org/#/transaction/${h}`,
};

export default function Activity() {
  const txs = loadTxs();

  return (
    <div className="px-5 pt-6">
      <h1 className="font-outfit text-2xl font-extrabold">Activity</h1>
      <p className="mt-1 font-sans text-xs text-[#6B7280]">Transactions broadcast from this device</p>

      {txs.length === 0 ? (
        <div className="mt-16 flex flex-col items-center text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-[#1F2430] bg-[#12141A]">
            <Clock className="h-7 w-7 text-[#6B7280]" />
          </div>
          <p className="mt-4 font-outfit text-sm font-semibold text-white">No activity yet</p>
          <p className="mt-1 max-w-xs font-sans text-xs text-[#6B7280]">
            Your sent transactions will appear here with live explorer links.
          </p>
        </div>
      ) : (
        <div className="mt-6 space-y-2.5">
          {txs.map((t, i) => {
            const chain = CHAINS.find((c) => c.id === t.chainId);
            return (
              <div key={i} data-testid="activity-tx-row" className="flex items-center gap-3 card-surface p-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#EF4444]/10">
                  <ArrowUpRight className="h-5 w-5 text-[#EF4444]" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-outfit text-sm font-semibold text-white">Sent {t.symbol}</p>
                  <p className="truncate font-sans text-xs text-[#6B7280]">To {t.to}</p>
                </div>
                <div className="text-right">
                  <p className="font-rajdhani text-sm font-semibold text-white">-{fmtNum(t.amount)} {t.symbol}</p>
                  <a
                    href={(explorer[t.chainId] || (() => "#"))(t.hash)}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 font-sans text-[10px] text-neon"
                  >
                    View <ExternalLink className="h-3 w-3" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
